import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  broadcastSettingsData: null,
  loading: false,
  error: false,
};

const setBroadcastSettings = (state, action) => {
  return updateObject(state, { broadcastSettingsData: action.broadcastSettingsData, loading: false, error: false });
};

const fetchBroadcastSettingsFailed = (state) => {
  return updateObject(state, { error: true, loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_BROADCAST_SETTINGS: return updateObject(state, { loading: true });
    case actionTypes.SET_BROADCAST_SETTINGS: return setBroadcastSettings(state, action);
    case actionTypes.FETCH_BROADCAST_SETTINGS_FAILED: return fetchBroadcastSettingsFailed(state);
    default: return state;
  }
};

export default reducer;
